(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-cta"] && !Shopify.designMode) return;
  try {
    
  function initializeContactSuccessModals(root) {
    root.querySelectorAll('[data-contact-success-modal]').forEach((dialog) => {
      if (dialog.dataset.initialized === 'true') return;

      dialog.dataset.initialized = 'true';
      const fallback = dialog.previousElementSibling;
      const form = dialog.closest('form');

      dialog.querySelectorAll('[data-contact-success-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });

      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;

        const bounds = dialog.getBoundingClientRect();
        const clickedOutside =
          event.clientX < bounds.left ||
          event.clientX > bounds.right ||
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom;

        if (clickedOutside) dialog.close();
      });

      dialog.addEventListener('close', () => {
        form?.querySelector('.contact-form__submit')?.focus();
      });

      if (typeof dialog.showModal !== 'function') return;

      try {
        dialog.showModal();
        if (fallback?.hasAttribute('data-contact-success-fallback')) {
          fallback.hidden = true;
        }
      } catch {
        if (fallback?.hasAttribute('data-contact-success-fallback')) {
          fallback.hidden = false;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeContactSuccessModals(document), { once: true });
  } else {
    initializeContactSuccessModals(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeContactSuccessModals(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
